import { type RouteRecordRaw } from "vue-router";
import { canAccess, haveOneAccess, permissionList } from "@/utilities/authorization";

const reportRoutes: RouteRecordRaw[] = [
    {
        name: 'report-navigation',
        path: '/report/navigation',
        component: () => import('@/views/report/ReportNavigation.vue'),
        beforeEnter: () => haveOneAccess([permissionList.READ_SALES_REPORT]) ? true : { name: 'dashboard' },
    },
    {
        name: 'revenue-report',
        path: '/report/revenue',
        component: () => import('@/views/report/revenueReport/RevenueReportDashboard.vue'),
        beforeEnter: () => canAccess(permissionList.READ_SALES_REPORT) ? true : { name: 'report-navigation' },
    },
    {
        name: 'order-report',
        path: '/report/order',
        component: () => import('@/views/report/orderReport/OrderReportDashboard.vue'),
        beforeEnter: () => canAccess(permissionList.READ_SALES_REPORT) ? true : { name: 'report-navigation' },
    },
]

export default reportRoutes
